module.exports = __webpack_public_path__ + "images/bAndW-2866ce80b46f9bba11492ad818272050.jpg";